import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import useApi from '@/hooks/useApi';
import useApp from '@/pages/App.context';
import useSign from '@/pages/SignLayout.context';
import useViewAndDownload from '@/pages/Sign/useViewAndDownload';
import SuspenseLoader from '@/components/SuspenseLoader/SuspenseLoader';
import Button from '@/components/Button';
import styles from './Success.module.scss';

const Success = () => {
  const { t } = useTranslation(['sign']);
  const { setAppTitle } = useApp();
  const { signerId, workflowId } = useParams();
  const { loadAllData } = useSign();
  const navigate = useNavigate();
  const [getMe, { error: errorMe }] = useApi('users.me');
  const [sendSignComplete, { loading, response }] = useApi('sign.complete');

  useEffect(() => {
    if (workflowId) {
      void sendSignComplete({ workflowId });
    }
  }, [sendSignComplete, workflowId]);

  useEffect(() => {
    if (response) {
      if (response.success) {
        loadAllData();
      } else {
        toast.error(t('sign:success:error'));
        void navigate(`/sign/${workflowId}/${signerId}/welcome`, {
          replace: true,
        });
      }
    }
  }, [loadAllData, navigate, response, signerId, t, workflowId]);

  useEffect(() => {
    void getMe();
  }, [getMe]);

  useEffect(() => {
    setAppTitle(t('sign:success.title'));
  }, [setAppTitle, t]);

  const buttons = useViewAndDownload({});

  if (!workflowId || loading) {
    return <SuspenseLoader />;
  }

  return (
    <div className={styles.pane}>
      <h1 className={styles.h1}>{t('sign:success.headline')}</h1>
      <div
        className={styles.content}
        dangerouslySetInnerHTML={{
          __html: t('sign:success.desc').replaceAll('\n', '<br>'),
        }}
      />
      <div className={styles.buttons}>
        {buttons.view}
        {buttons.download}
      </div>
      <div className={`${styles.content} ${styles.subtle}`}>
        {t('sign:success.register_paragraph')}
      </div>
      {errorMe !== null && (
        <div className={styles.buttons}>
          <Button as="link" variant="tertiary" to="/auth/register">
            {t('sign:success.register')}
          </Button>
        </div>
      )}
    </div>
  );
};

export default Success;
